export default __webpack_public_path__ + "static/media/hamburger-menu-dark.0de692f1.svg";